import { Search } from 'lucide-react';

import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Empty, EmptyIcon, EmptyTitle, EmptyDescription } from '@/components/ui/empty';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';

import { useTogalIntegrations } from '@/data/togalIntegration';

const ViewTogalIntegrationDetailsDialog = ({ onClose, companyUid }) => {
  const togalIntegrations = useTogalIntegrations(companyUid);

  let content = (
    <Empty>
      <EmptyIcon>
        <Search />
      </EmptyIcon>
      <EmptyTitle>No Togal Integrations</EmptyTitle>
      <EmptyDescription>No Togal integrations installed for this company</EmptyDescription>
    </Empty>
  );

  if (togalIntegrations.data && togalIntegrations.data.length > 0) {
    content = (
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Email</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>Session</TableHead>
            <TableHead>Installed</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {togalIntegrations.data.map((integration) => (
            <TableRow key={integration.uid}>
              <TableCell className="font-medium">{integration.togal_email || '-'}</TableCell>
              <TableCell>
                <Badge variant="success">{integration.status}</Badge>
              </TableCell>
              <TableCell>{integration.session_status}</TableCell>
              <TableCell>
                {new Date(integration.create_ts).toLocaleDateString(undefined, {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric'
                })}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    );
  }

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[600px]">
        <DialogHeader>
          <DialogTitle>Togal API Integration Details</DialogTitle>
          <DialogDescription>View the details of the Togal API integration. The following users have installed the integration:</DialogDescription>
        </DialogHeader>
        {content}
      </DialogContent>
    </Dialog>
  );
};

export default ViewTogalIntegrationDetailsDialog;
